export default __webpack_public_path__ + "static/media/431.e4769c4d.jpg";